import React from 'react';
import styled from 'styled-components';

import IconLink from '../../../../../common/ui/IconLink';
import Book from '../../../../../icons/book3.svg';
import Mail from '../../../../../icons/mail.svg';

import { StyledTitle, StyledText } from './styles';

const Support = (props) => {
  const { app } = props;
  const { developerName, supportEmail, websiteUrl, documentationUrl } = app;

  return (
    <div>
      <StyledTitle>Support</StyledTitle>
      <StyledText>
        This app is built and supported by{' '}
        <a target="_blank" rel="noreferrer" href={websiteUrl}>
          {developerName}
        </a>
        .
      </StyledText>
      <StyledLinks>
        {documentationUrl && (
          <IconLink startIcon={Book} href={documentationUrl}>
            View Documentation
          </IconLink>
        )}
        {supportEmail && (
          <IconLink startIcon={Mail} mailTo={supportEmail}>
            {supportEmail}
          </IconLink>
        )}
      </StyledLinks>
    </div>
  );
};

const StyledLinks = styled.div`
  margin-top: 30px;
`;

export default Support;
